<div class="container-fluid py-3">
  <div class="row">

    <!-- Header -->
    <div class="col-12 mb-3 d-flex align-items-center gap-2">
      <button
        (click)="goBack()"
        type="button"
        class="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
        style="height: 2.4rem; width: 2.4rem;"
        ngbTooltip="Volver">
        <i class="material-icons"
          style="font-size: 1.1rem;">
          arrow_back
        </i>
      </button>
      <h4 class="mb-0"><b>Detalle de servicio externo</b></h4>
    </div>

    @if (!log) {
      <div class="col-12 text-center py-5">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem;"
          role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>
    }

    @if (log) {

      <!-- Metadatos -->
      <div class="col-12 mb-4">
        <div class="bg-white rounded-3 shadow-sm p-4">

          <h6 class="text-secondary fw-600 mb-3 text-uppercase"
            style="font-size: calc(0.6rem + 0.4vh); letter-spacing: 0.05em;">
            Información del registro
          </h6>

          <div class="row g-3">

            <div class="col-6 col-md-4 col-xl-3">
              <div class="text-secondary mb-1"
                style="font-size: calc(0.6rem + 0.4vh);">
                Fecha
              </div>
              <div class="fw-500">
                {{ log.createdAt | dateToMoment: 'DD/MM/YYYY HH:mm:ss' }}
              </div>
            </div>

            <div class="col-6 col-md-4 col-xl-3">
              <div class="text-secondary mb-1"
                style="font-size: calc(0.6rem + 0.4vh);">
                Servicio
              </div>
              <div class="fw-500">{{ log.serviceLabel }}</div>
            </div>

            <div class="col-6 col-md-4 col-xl-3">
              <div class="text-secondary mb-1"
                style="font-size: calc(0.6rem + 0.4vh);">
                Dirección
              </div>
              <span
                class="badge rounded-pill"
                [ngClass]="{
                  'text-bg-primary': log.direction === 'outbound',
                  'text-bg-info': log.direction === 'inbound'
                }">
                {{ log.directionLabel }}
              </span>
            </div>

            <div class="col-6 col-md-4 col-xl-3">
              <div class="text-secondary mb-1"
                style="font-size: calc(0.6rem + 0.4vh);">
                Método
              </div>
              <code class="fw-500">{{ log.method }}</code>
            </div>

            <div class="col-12 col-md-8">
              <div class="text-secondary mb-1"
                style="font-size: calc(0.6rem + 0.4vh);">
                URL
              </div>
              <div
                class="fw-500 text-break"
                style="word-break: break-all;">
                {{ log.url }}
              </div>
            </div>

            <div class="col-6 col-md-4 col-xl-3">
              <div class="text-secondary mb-1"
                style="font-size: calc(0.6rem + 0.4vh);">
                Status Code
              </div>
              <span
                class="badge rounded-pill"
                [ngClass]="log.statusClass">
                {{ log.statusCode ?? 'Sin respuesta' }}
              </span>
            </div>

            @if (log.error) {
              <div class="col-12">
                <div class="text-secondary mb-1"
                  style="font-size: calc(0.6rem + 0.4vh);">
                  Error
                </div>
                <span class="text-danger fw-500">{{ log.error }}</span>
              </div>
            }

            @if (log.movementId) {
              <div class="col-6 col-md-4 col-xl-3">
                <div class="text-secondary mb-1"
                  style="font-size: calc(0.6rem + 0.4vh);">
                  Movement ID
                </div>
                <code>{{ log.movementId }}</code>
              </div>
            }

            @if (log.neighborhoodId) {
              <div class="col-6 col-md-4 col-xl-3">
                <div class="text-secondary mb-1"
                  style="font-size: calc(0.6rem + 0.4vh);">
                  Neighborhood ID
                </div>
                <code>{{ log.neighborhoodId }}</code>
              </div>
            }

          </div>
        </div>
      </div>

      <!-- Bloques JSON -->
      <div class="col-12 col-md-6 mb-4">
        <div class="bg-white rounded-3 shadow-sm p-4 h-100">
          <h6
            class="text-secondary fw-600 mb-3 text-uppercase"
            style="font-size: calc(0.6rem + 0.4vh); letter-spacing: 0.05em;">
            Request Headers
          </h6>
          <pre
            class="bg-light rounded p-3 mb-0"
            style="font-size: 0.78rem; max-height: 320px; overflow-y: auto;">{{ log.requestHeadersParsed | json }}</pre>
        </div>
      </div>

      <div class="col-12 col-md-6 mb-4">
        <div class="bg-white rounded-3 shadow-sm p-4 h-100">
          <h6
            class="text-secondary fw-600 mb-3 text-uppercase"
            style="font-size: calc(0.6rem + 0.4vh); letter-spacing: 0.05em;">
            Request Body
          </h6>
          <pre
            class="bg-light rounded p-3 mb-0"
            style="font-size: 0.78rem; max-height: 320px; overflow-y: auto;">{{ log.requestBodyParsed | json }}</pre>
        </div>
      </div>

      <div class="col-12 col-md-6 mb-4">
        <div class="bg-white rounded-3 shadow-sm p-4 h-100">
          <h6
            class="text-secondary fw-600 mb-3 text-uppercase"
            style="font-size: calc(0.6rem + 0.4vh); letter-spacing: 0.05em;">
            Response Headers
          </h6>
          <pre
            class="bg-light rounded p-3 mb-0"
            style="font-size: 0.78rem; max-height: 320px; overflow-y: auto;">{{ log.responseHeadersParsed | json }}</pre>
        </div>
      </div>

      <div class="col-12 col-md-6 mb-4">
        <div class="bg-white rounded-3 shadow-sm p-4 h-100">
          <h6
            class="text-secondary fw-600 mb-3 text-uppercase"
            style="font-size: calc(0.6rem + 0.4vh); letter-spacing: 0.05em;">
            Response Body
          </h6>
          <pre
            class="bg-light rounded p-3 mb-0"
            style="font-size: 0.78rem; max-height: 320px; overflow-y: auto;">{{ log.responseBodyParsed | json }}</pre>
        </div>
      </div>

    }

  </div>
</div>
